"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BALANCE_SHEET = exports.DEBT_AND_DEBT_LIKE = exports.REPORTED_INCOME_STATEMENT = exports.NET_WORKING_CAPITAL = exports.QUALITY_OF_EARNINGS = exports.structuredDocumentSubtypeCodes = exports.ALL_STRUCTURED_DOCUMENTS = void 0;
var QUALITY_OF_EARNINGS = 'QofE';
exports.QUALITY_OF_EARNINGS = QUALITY_OF_EARNINGS;
var NET_WORKING_CAPITAL = 'NWC';
exports.NET_WORKING_CAPITAL = NET_WORKING_CAPITAL;
var REPORTED_INCOME_STATEMENT = 'PandL';
exports.REPORTED_INCOME_STATEMENT = REPORTED_INCOME_STATEMENT;
var DEBT_AND_DEBT_LIKE = 'DDL';
exports.DEBT_AND_DEBT_LIKE = DEBT_AND_DEBT_LIKE;
var BALANCE_SHEET = 'BsV';
exports.BALANCE_SHEET = BALANCE_SHEET;
exports.ALL_STRUCTURED_DOCUMENTS = [
    QUALITY_OF_EARNINGS,
    NET_WORKING_CAPITAL,
    REPORTED_INCOME_STATEMENT,
    DEBT_AND_DEBT_LIKE,
    BALANCE_SHEET,
];
exports.structuredDocumentSubtypeCodes = (_a = {},
    _a[QUALITY_OF_EARNINGS] = 200,
    _a[NET_WORKING_CAPITAL] = 300,
    _a[DEBT_AND_DEBT_LIKE] = 400,
    _a);
